import { render, staticRenderFns } from "./yeliao.vue?vue&type=template&id=05a3c8be&scoped=true&"
import script from "./yeliao.vue?vue&type=script&lang=js&"
export * from "./yeliao.vue?vue&type=script&lang=js&"
import style0 from "./yeliao.vue?vue&type=style&index=0&id=05a3c8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3c8be",
  null
  
)

export default component.exports